"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const index_js_1 = require("./index.js");
(0, index_js_1.registerIcon)('cross', [{ tag: 'path', att: { 'fill-rule': 'evenodd', 'clip-rule': 'evenodd', d: 'm12 13.4142 4.9497 4.9497 1.4142-1.4142L13.4142 12l4.9497-4.9498-1.4142-1.4142L12 10.5857 7.0502 5.636 5.636 7.0502 10.5857 12 5.636 16.9497l1.4142 1.4142L12 13.4142z' } }]);
